import React from 'react';
import Nav from '../Page Components/Nav';
import Footer from "../Page Components/Footer";
import Card from "../Co Components/SquareCards";
import Square from "../Co Components/SquareCards";
import Title from "../Co Components/Titles";
import homehero from '../assets/Images/homehero.png';
import Rectangle from "../Co Components/RectangleCards";
import LineButton from "../Co Components/LineButton";
import { useEffect } from 'react';

const Services = () => {
    useEffect(() => {
        window.scrollTo(0, 0)


    });
    return (
        <>

            <Nav />
            <Title className={'mb-5'} header={"our"} body={"SERVICES"} />
            <LineButton />

            <Footer />
        </>
    );

}

export default Services;